import { BadgeText } from '@shared/components'
import { Avatar, Button, Card, Divider, Flex, theme, Tooltip } from 'antd'
import { LoginCurve, LogoutCurve } from 'iconsax-react'

import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { useStyles } from './styles'

export type IntegrationCardProps = {
  isPending?: boolean
  onLogin?: () => void
  onLogout?: () => void
  isLoading?: boolean
  logo?: string | ReactNode
  title: string
  description?: string
  isConnected?: boolean
  canUseMailbox?: boolean
}

export const IntegrationCard = ({
  isPending,
  onLogin,
  onLogout,
  isLoading,
  logo,
  title,
  description,
  isConnected,
  canUseMailbox
}: IntegrationCardProps) => {
  const { token } = theme.useToken()

  const { styles } = useStyles()
  const { t } = useTranslation()

  return (
    <Card loading={isLoading}>
      <Card.Meta
        avatar={<Avatar src={logo} shape="square" size={36} alt="" />}
        title={
          <Tooltip title={t(isConnected ? 'connected' : 'disconnected')}>
            <span>
              <BadgeText
                text={title}
                color={isConnected ? token.green5 : token.red5}
              />
            </span>
          </Tooltip>
        }
        description={description}
        className={styles.cardMeta}
      />

      {canUseMailbox && <Divider className={styles.divider} />}

      <Flex>
        {isConnected ? (
          <Button
            onClick={onLogout}
            icon={<LogoutCurve size={16} />}
            loading={isPending}
          >
            {t('logout')}
          </Button>
        ) : (
          canUseMailbox && (
            <Button
              onClick={onLogin}
              icon={<LoginCurve size={16} />}
              loading={isPending}
            >
              {t('connect')}
            </Button>
          )
        )}
      </Flex>
    </Card>
  )
}
